module.exports = __webpack_public_path__ + "img/serve-icon-3.ce4fd3d5.png";